import React from 'react';
import { useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

const LegalBondNotice: React.FC = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return (
    <div className="alert alert-warning mt-4" role="alert">
      <div className="d-flex align-items-center mb-2">
        <i className="material-icons mr-2" style={{ fontSize: '20px' }} aria-hidden="true">
          warning
        </i>
        <strong>Confirmação de Vínculo Legal</strong>
      </div>
      <p className="mb-0">
        Ao prosseguir, declaro que estou legalmente apto para gerar cotação e eventual emissão de
        apólice de seguro garantia. Estou ciente que uma vez emitida a apólice não há possibilidade
        de cancelamento ficando a <strong>{profile.company_data?.data?.razao_social}</strong>{' '}
        responsável pelas obrigações por ela geradas.
      </p>
    </div>
  );
};

export default LegalBondNotice;
